import React from 'react'
import img1 from "../../assets/1.jpg";
import img2 from "../../assets/2.jpg";
import img3 from "../../assets/3.jpg";

import './home.css'

function Home() {
  return (
    <div className='home-container mb-5 mt-5'>
    <h3 className='mb-5 home-title'>Textkompletteringar på befintliga stenar </h3>
      <p className='content-home '>Vi har specialiserat oss på att utföra textkomplettering på befintliga stenar när en ny text skall graveras. Metoden är att använda bläster som under högt tryck sprutar blästersand på stenen. Vi har flera års erfarenhet inom textkomplettering, förgyllning, ommålning på befintliga gravstenar, rengörningar på gravstenen, ommontering av gravstenar, och stenhuggning. Vårt mål är att göra dig nöjd som kund, är effektiva och noggranna. Vi erbjuder inom Västra Götalands län och Halland.</p>
      <div className='row d-flex gap-3 justify-content-between'>
  
      <div className='col home-images'> <img width="100%" src={img2} alt="logo" /></div>
      <div className='col home-images'> <img width="100%" src={img1} alt="logo" /></div>
      <div className='col home-images'> <img width="100%" src={img3} alt="logo" /></div>
      </div>
    </div>
  )
}

export default Home 